import { useEffect, useState } from "react";
import { FiPhone } from "react-icons/fi";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { validateFields, commonOnChange, commonOnSelect, isValidObject, copyToClipboard, generatePassword } from "../../../utils";
import { GoPerson } from "react-icons/go";
import { appApis } from "../../../constants";
import { MdEmail } from "react-icons/md";
import { useApiRequest } from "../../../hooks/useApiRequest";
import ToggleSwitch from "../../../Common/Checkbox";
import { BiCopy } from "react-icons/bi";
import { shallowEqual, useSelector } from "react-redux";

const getPayload = (stateData) => {
    const { fullName, mobileNo, email, roleId, status, password } = stateData;
    return {
        name: fullName,
        mobileNo,
        email,
        roleId,
        status: status ? "active" : "inactive",
        password
    }
}

const AddUser = ({ show, hideModal, userData, getInstData }) => {
    const [details, setDetails] = useState({
        fullName: "",
        email: "",
        mobileNo: "",
        role: "",
        password: "",
        status: true,
        fullNameErr: null,
        emailErr: null,
        mobileNoErr: null,
        roleErr: null
    });

    const { fullName, email, mobileNo, role, status, fullNameErr, mobileNoErr, emailErr, roleErr, password } = details;
    const { request: submitRequest, loading } = useApiRequest();
    const { filters } = useSelector(({ inventory }) => ({
        filters: inventory.filters,
    }), shallowEqual);

    const onChangeHandler = (event) => commonOnChange(event, setDetails);
    const onSelectHandler = (event) => commonOnSelect(event, setDetails);

    const submit = () => {
        validateFields(
            {
                fullNameErr: [fullName, "text"],
                emailErr: [email, "email"],
                mobileNoErr: [mobileNo, "phone"],
                roleErr: [role, "text"]
            },
            setDetails,
            () => {
                const payload = getPayload(details);
                const isUpdate = userData?.userId ?? null;
                if (isUpdate) delete payload["password"];
                submitRequest({
                    method: isUpdate ? "PATCH" : "POST",
                    url: `${appApis.getUsers}${isUpdate ? `/${isUpdate}` : ""}`,
                    body: payload,
                    onSuccess: () => {
                        getInstData();
                        setTimeout(hideModal, 1000);
                    }
                })
            }
        )
    }

    useEffect(() => {
        let obj = {
            password: generatePassword(12)
        }
        if (isValidObject(userData)) {
            const roleName = userData?.Roles?.[0]?.roleName ?? "";
            obj = {
                ...obj,
                fullName: userData?.name ?? "",
                email: userData?.email ?? "",
                mobileNo: userData?.mobileNo ?? "",
                role: roleName,
                roleId: (filters?.userRoles ?? []).find(item => item.name == roleName)?.roleId || 0,
                status: (userData?.status ?? "active") == "active" ? true : false
            }
        }
        setDetails(prev => ({
            ...prev,
            ...obj
        }));
    }, [userData])


    return <ModalElement FooterComponent={<div className="submit-btn text-center mb-3">
        <ButtonElement className="submit-btn text-center" style={{ position: 'absolute', bottom: '20px', left: '0', right: '0', background: 'white', padding: '15px', borderTop: '1px solid #dee2e6' }} text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" loading={loading} />
    </div>}
        size="lg" show={show} title={`${userData?.email ? "Update" : "Add"} User`} onHide={hideModal}>
        <div className="text-start">
            <div className="installer-personal mb-3">
                <div className="d-flex justify-content-between align-items-center me-2">
                    <h5 className="mb-3">Personal Details</h5>
                    <ToggleSwitch
                        label="Status"
                        value={status}
                        onChange={(value) => setDetails(prev => ({ ...prev, status: value }))}
                    />
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <InputElement
                            label={"Full Name"}
                            placeholder={"Enter Full Name"}
                            name={"fullName"}
                            value={fullName}
                            error={fullNameErr}
                            icon={<GoPerson size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-md-6 mb-2">
                        <InputElement
                            label={"Email"}
                            placeholder={"Enter Email Id"}
                            name={"email"}
                            value={email}
                            error={emailErr}
                            icon={<MdEmail size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-md-6 mb-2">
                        <InputElement
                            label={"Mobile Number"}
                            placeholder={"Enter Mobile Number"}
                            name={"mobileNo"}
                            value={mobileNo}
                            error={mobileNoErr}
                            maxLen="10"
                            icon={<FiPhone size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-md-6 mb-2">
                        <SearchableDropdown
                            label={"User Role"}
                            placeholder={"Select User Role"}
                            value={role}
                            error={roleErr}
                            options={filters?.userRoles ?? []}
                            onSelect={(value) => onSelectHandler({ target: { name: "role", value } })}
                        />
                    </div>
                    {!userData?.email ? <div>
                        <InputElement
                            type="password"
                            label={"Password"}
                            name={"password"}
                            value={password}
                            error={false}
                            disable={true}
                            icon={<BiCopy size={20} onClick={() => copyToClipboard(password)} />}
                        />
                    </div> : null}
                </div>
            </div>
        </div>
    </ModalElement>
}

export default AddUser;